// @flow
import React from 'react'

// components
import { fieldsClasses, formGroupClasses, labelClasses } from '../../Components/_formFields/fields'
import StringEnum from '../../Core/Components/_formFields/StringEnum'
import FieldLabel from '../../Core/Components/FieldLabel'
import { Popover } from '../index'

// types
import type { DefaultMiniAppProps } from './'

type PhoneAppProps = DefaultMiniAppProps & {}

export default class AcquisitionCppMiniApp extends React.Component<PhoneAppProps> {
  handleOnChange = (value: string) => {
    const { onChangeFormData, formData } = this.props
    let newData = formData
    switch (value) {
      case 'new':
        newData = newData.setIn(['isVehicleNew'], true).setIn(['vehicleImported'], false)
        break
      case 'used':
        newData = newData.setIn(['isVehicleNew'], false).setIn(['vehicleImported'], false)
        break
      case 'abroad':
        newData = newData.setIn(['isVehicleNew'], false).setIn(['vehicleImported'], true)
        break
    }
    onChangeFormData(newData)
  }

  render() {
    const { domain, specification, data, content, inputHelps, miniAppData } = this.props
    let value = 'new'
    if (data.vehicleImported) {
      value = 'abroad'
    } else if (!data.isVehicleNew) {
      value = 'used'
    }

    let wrapperClassName = 'text-right'
    if (miniAppData.acquisitionCppMiniApp && miniAppData.acquisitionCppMiniApp.wrapperClassName) {
      wrapperClassName = miniAppData.acquisitionCppMiniApp.wrapperClassName
    }

    return (
      <div className={formGroupClasses['acquisitionCppMiniApp']}>
        <div className={labelClasses['string-enum']}>
          <FieldLabel
            id="acquisitionType"
            isRequired={specification.required}
            label={content.fieldNames.acquisitionTypeCpp}
          />
        </div>
        <div className={fieldsClasses['string-enum']}>
          <StringEnum
            {...specification}
            domain={{ ...domain, values: ['new', 'used', 'abroad'] }}
            onChange={this.handleOnChange}
            value={value}
            valueNames={content.valueNames}
          />
        </div>
        <div className={`col-2 col-sm-3 order-0 order-sm-0 ${wrapperClassName}`}>
          {inputHelps && inputHelps.vehicleImported && inputHelps.vehicleImported.content && (
            <Popover
              content={inputHelps.vehicleImported.content}
              id="IDvehicleImported"
              title={inputHelps.vehicleImported.title}
            />
          )}
        </div>
      </div>
    )
  }
}
